import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SurveyBuilderForm from '../components/SurveyBuilderForm';

function SurveyBuilderPage() {
  const navigate = useNavigate();
  const { id } = useParams(); // Will be undefined for new surveys

  const handleCancel = () => {
    navigate('/'); // Go back to home
  };

  return (
    <main className="survey-builder-page">
      <SurveyBuilderForm 
        surveyId={id} 
        onCancel={handleCancel}
      />
    </main>
  );
}

export default SurveyBuilderPage;
